import React from 'react';
import { Navigate } from 'react-router-dom';
type Props = {
  path: string;
};
const RedirectionPath = ({ path }: Props) => {
  return <Navigate to={path} replace />;
};

export default RedirectionPath;
